export default defineNuxtRouteMiddleware((to) => {
  if (to.path.length > 1 && to.path.endsWith('/')) {
    return navigateTo({ path: to.path.slice(0, -1), query: to.query }, { redirectCode: 301 })
  }
})
